<template>
  <div class="form-group">
    <div class="form-check">
      <input class="form-check-input"
             v-on="inputListeners"
             type="checkbox"
             v-bind:checked="checked"
             :id="id"
             v-bind:class="{'is-invalid': validation.$error, 'required': hasRequired}"
             v-bind="$attrs" />
      <label v-if="label"
             :for="id"
             v-bind:class="{required: hasRequired}">
        {{label}}
      </label>
      <div class="invalid-feedback" v-if="errorMessage">
        {{errorMessage}}
      </div>
    </div>
  </div>
</template>

<script>
import { ValidationMixin } from '@/js/Mixins';

export default {
  name: 'base-checkbox',
  inheritAttrs: false,
  mixins: [ValidationMixin],
  props: {
    label: String,
    checked: Boolean,
  },
  data() {
    return {
      id: null,
    };
  },
  model: {
    prop: 'checked',
    event: 'change',
  },
  mounted() {
    this.id = `checkbox-${this._uid}`;
  },
  computed: {
    inputListeners() {
      const vm = this;
      return Object.assign({}, this.$listeners, {
        change(event) {
          vm.validation.$touch();
          vm.$emit('change', event.target.checked);
        },
      });
    },
  },
};
</script>

<style scoped>

</style>
